import { IncomingMessage } from 'http';
import { fechFromBPartsApi } from '../utils';

export const fetchUserCars = async (
  {
    locale,
    csrftoken,
  }: {
    locale: string;
    csrftoken: string;
  },
  req?: IncomingMessage
): Promise<TCarCompleteInfo[]> => {
  const data = await fechFromBPartsApi(`/${locale}/shop/user_cars/list-last`, {
    headers: new Headers({
      ...(!!req ? (req?.headers as HeadersInit) : {}),
      'Content-Type': 'application/json',
      'X-CSRFToken': csrftoken || '',
    } as HeadersInit),
    credentials: 'include',
  });
  return data.json();
};

export default fetchUserCars;
